import { lenisInstance } from '../scroll';

export default () => ({
    selected: -1,

    scrollToAccordion(event) {
        const accordionTop = event.currentTarget.parentElement.offsetTop;

        lenisInstance.scrollTo(accordionTop);
    }
});